import { videos } from 'components/home/content/review-carousel.content';
import { PRODUCT_SKUS } from 'lib/constants/product-skus';

export type PillItem = {
  text: string;
  trademark?: boolean;
  registered?: boolean;
};

export type ProductCarouselItemType = {
  title: string;
  microNavTitle?: string;
  label?: string | React.ReactNode;
  pills?: PillItem[];
  media: {
    src?: string;
    videoSrc?: string;
    playbackId?: string;
    devPlaybackId?: string;
    alt: string;
    width: number;
    height: number;
    webmVideoSrc?: string;
  };
  labelColor?:
    | 'seedgreen'
    | 'snowwhite'
    | 'amprimary'
    | 'pmprimary'
    | 'dmprimary';
  primaryButton: {
    label: string;
    url: string;
  };
  sku?: string;
  note?: string;
  desktopNote?: string;
};

const ds01ProductContent: ProductCarouselItemType = {
  title: 'Daily Synbiotic',
  microNavTitle: 'Gut Health',
  label: 'Bestseller',
  pills: [{ text: 'DS–01', registered: true }],
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1762362135/library/carousel/ds01-carousel-poster.png',
    videoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1755780716/library/carousel/Seed_DS01_Jar_1080-web_hd_720p.mov',
    webmVideoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1758217610/library/carousel/ds01_webm.webm',
    playbackId: 'c6C1Y5Bwf00B6b9gQ25X9MpyFX8LMg43ier45AvpYoRs',
    devPlaybackId: '3jJ4yBBBZLDlmc7x7JKXfW02sehzxWMUyXpvwmIQPnJY',
    alt: 'DS-01 Daily Synbiotic',
    width: 360,
    height: 360,
  },
  primaryButton: {
    label: 'Shop Now',
    url: '/daily-synbiotic',
  },
  sku: PRODUCT_SKUS.DAILY_SYNBIOTIC,
  labelColor: 'seedgreen',
};

const dm02ProductContent: ProductCarouselItemType = {
  title: 'Daily Multivitamin',
  pills: [{ text: 'DM–02', registered: true }],
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1762362131/library/carousel/dm02-carousel-poster.png',
    videoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1758201890/library/carousel/dm02clipped-mov_hd_720p_small.mov',
    webmVideoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1757706601/library/carousel/dm02clipped.webm',
    playbackId: 'c6C1Y5Bwf00B6b9gQ25X9MpyFX8LMg43ier45AvpYoRs',
    devPlaybackId: '3jJ4yBBBZLDlmc7x7JKXfW02sehzxWMUyXpvwmIQPnJY',
    alt: 'DM-02 Daily Multivitamin',
    width: 360,
    height: 360,
  },
  primaryButton: {
    label: 'Shop Now',
    url: '/daily-multivitamin',
  },
  sku: PRODUCT_SKUS.DAILY_MULTIVITAMIN,
  labelColor: 'dmprimary',
};

// const dsDuoProductContent: ProductCarouselItemType = {
//   title: 'Daily Essentials Duo',
//   label: 'Bundle + Save 25%',
//   media: {
//     src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1762180863/library/carousel/_products.png',
//     alt: 'DS-duo Daily Essentials Duo',
//     width: 240,
//     height: 157,
//   },
//   primaryButton: {
//     label: 'Shop Now',
//     url: '/daily-essentials-duo',
//   },
//   note: 'Starting at $67.49',
//   desktopNote: 'Starting at $67.49 per month',
//   labelColor: 'seedgreen',
// };

const pm02ProductContent: ProductCarouselItemType = {
  title: 'Sleep + Restore',
  pills: [{ text: 'PM–02', registered: true }],
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1762362130/library/carousel/pm02-carousel-poster.png',
    videoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1758201889/library/carousel/pm02clipped-mov_hd_720p_small.mov',
    webmVideoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1757706600/library/carousel/pm02clipped.webm',
    playbackId: 'c6C1Y5Bwf00B6b9gQ25X9MpyFX8LMg43ier45AvpYoRs',
    devPlaybackId: '3jJ4yBBBZLDlmc7x7JKXfW02sehzxWMUyXpvwmIQPnJY',
    alt: 'PM-02 Sleep + Restore',
    width: 360,
    height: 360,
  },
  primaryButton: {
    label: 'Shop Now',
    url: '/sleep-restore',
  },
  sku: PRODUCT_SKUS.SLEEP_RESTORE,
  labelColor: 'pmprimary',
};

export const productContent = {
  title: '2-in-1 synbiotics for whole body health.',
  body: 'Seed’s probiotics and prebiotics restore optimal microbiome health, with scientifically studied strains shown to promote systemic benefits.',
  primaryButton: {
    label: 'Shop all',
    url: '/products',
  },
  reviews: {
    videos: videos,
  },
  items: [
    ds01ProductContent,
    {
      title: 'Pediatric Daily Synbiotic',
      microNavTitle: 'Kids’ Gut Health',
      pills: [{ text: 'PDS–08', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753458405/library/carousel/pds08-green-lighter.png',
        videoSrc:
          'https://res.cloudinary.com/dljz0lko8/video/upload/v1755121850/library/carousel/Seed_PDS08_Jar_1080-web_hd_720p.mov',
        webmVideoSrc:
          'https://res.cloudinary.com/dljz0lko8/video/upload/v1758218246/library/carousel/pds_08_webm.webm',
        playbackId: '61EjIv6SXVFsvkOyKrtIahRipMPuvLGfd3YjFNpgvmo',
        devPlaybackId: '2BPGCAC02G4t52jB6mgnUG0033wocKDDqgcXbByo36ykc',
        alt: 'PDS-08 Pediatric Daily Synbiotic',
        width: 360,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: 'pds08-daily-kids-probiotic',
      },
      sku: PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC,
    },
    {
      title: 'Vaginal Synbiotic',
      microNavTitle: 'Vaginal Health',
      pills: [{ text: 'VS–01', trademark: true }],
      media: {
        videoSrc:
          'https://res.cloudinary.com/dljz0lko8/video/upload/v1755121850/library/carousel/Seed_VS01_Box_1080-web_hd_720p.mov',
        webmVideoSrc:
          'https://res.cloudinary.com/dljz0lko8/video/upload/v1758218247/library/carousel/vs_01_webm.webm',
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753458290/library/carousel/vs01-green-lighter.png',
        playbackId: 'hn6eszHn1C9TAW01dWLRErquE8ys9SQB3ZnX1G200ePjs',
        devPlaybackId: 'XBSEWIByvhqzhdA5NrBD9UgfXD6mNFW00AvjGvI02f01Po',
        alt: 'VS–01 Vaginal Synbiotic',
        width: 360,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '/vaginal-synbiotic',
      },
      sku: PRODUCT_SKUS.VAGINAL_SYNBIOTIC,
    },
  ] as ProductCarouselItemType[],
};

export const am02ProductContent: ProductCarouselItemType = {
  title: 'Energy + Focus',
  pills: [{ text: 'AM–02', registered: true }],
  media: {
    src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1762362130/library/carousel/am02-carousel-poster.png',
    videoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1758201889/library/carousel/am02clipped-mov_hd_720p_small.mov',
    webmVideoSrc:
      'https://res.cloudinary.com/dljz0lko8/video/upload/v1757686131/library/carousel/am02clipped.webm',
    playbackId: 'c6C1Y5Bwf00B6b9gQ25X9MpyFX8LMg43ier45AvpYoRs',
    devPlaybackId: '3jJ4yBBBZLDlmc7x7JKXfW02sehzxWMUyXpvwmIQPnJY',
    alt: 'AM-02 Energy + Focus',
    width: 360,
    height: 360,
  },
  primaryButton: {
    label: 'Shop Now',
    url: '/energy-focus',
  },
  sku: PRODUCT_SKUS.ENERGY_FOCUS,
  labelColor: 'amprimary',
};

export const npdProductContent = {
  ...productContent,
  title: 'Whole body health starts in the gut.',
  body: 'Formulations that provide sustained support using key scientifically and clinically studied ingredients',
  items: [
    ds01ProductContent,
    dm02ProductContent,
    am02ProductContent,
    pm02ProductContent,
  ] as ProductCarouselItemType[],
};

export const kidsItems = {
  items: [
    {
      title: 'Daily Energy, Sharpened Focus',
      label: 'New',
      pills: [{ text: 'AM–02', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392871/library/card/product-1.png',
        alt: 'product 1',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.ENERGY_FOCUS,
    },
    {
      title: 'Proactive Vaginal Care — Finally',
      pills: [{ text: 'VS–01', trademark: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-3.png',
        alt: 'product 3',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.VAGINAL_SYNBIOTIC,
    },
    {
      title: 'The Standard in Kids Probiotics',
      pills: [{ text: 'PDS–08', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-2.png',
        alt: 'product 2',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC,
    },
  ] as ProductCarouselItemType[],
};

export const gridItems = {
  items: [
    {
      title: 'Daily Energy, Sharpened Focus',
      label: 'New',
      pills: [{ text: 'AM–02', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392871/library/card/product-1.png',
        alt: 'product 1',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.ENERGY_FOCUS,
    },
    {
      title: 'Proactive Vaginal Care — Finally',
      pills: [{ text: 'VS–01', trademark: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-3.png',
        alt: 'product 3',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.VAGINAL_SYNBIOTIC,
    },
    {
      title: 'The Standard in Kids Probiotics',
      pills: [{ text: 'PDS–08', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-2.png',
        alt: 'product 2',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC,
    },
    {
      title: 'The Standard in Kids Probiotics',
      pills: [{ text: 'PDS–08', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-2.png',
        alt: 'product 2',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC,
    },
  ] as ProductCarouselItemType[],
};

export const itemsOverflow = {
  items: [
    {
      title: 'Daily Synbiotic',
      label: 'Bestseller',
      pills: [{ text: 'DS–01', registered: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392871/library/card/product-1.png',
        alt: 'product 1',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.DAILY_SYNBIOTIC,
    },
    {
      title: 'Daily Multivitamin',
      pills: [{ text: 'DM–02', trademark: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-2.png',
        alt: 'product 2',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.DAILY_MULTIVITAMIN,
    },
    {
      title: 'Energy + Focus',
      pills: [{ text: 'AM–02', trademark: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-3.png',
        alt: 'product 3',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.ENERGY_FOCUS,
    },
    {
      title: 'Sleep + Restore',
      pills: [{ text: 'PM–02', trademark: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-3.png',
        alt: 'product 3',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.SLEEP_RESTORE,
    },
    {
      title: 'Proactive Vaginal Care — Finally',
      pills: [{ text: 'VS–01', trademark: true }],
      media: {
        src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1750392872/library/card/product-3.png',
        alt: 'product 3',
        width: 300,
        height: 360,
      },
      primaryButton: {
        label: 'Shop Now',
        url: '#',
      },
      sku: PRODUCT_SKUS.VAGINAL_SYNBIOTIC,
    },
  ] as ProductCarouselItemType[],
};
